import { PDF_LIMITS } from '../constants';
import { getSize, readMagicBytes, readTail } from '../fileInputUtils';
import type { FileInput, ValidationResult } from '../types';
import { formatBytes } from '../utils';

export async function validatePdf(input: FileInput): Promise<ValidationResult> {
  const size = getSize(input);

  if (size < PDF_LIMITS.min)
    return { valid: false, reason: `Too small — minimum valid PDF is ~1 KB` };
  if (size > PDF_LIMITS.max)
    return { valid: false, reason: `Exceeds max size (${formatBytes(PDF_LIMITS.max)})` };

  // Check PDF magic bytes
  const magicBytes = await readMagicBytes(input, 5);
  const isPDF =
    magicBytes[0] === 0x25 &&
    magicBytes[1] === 0x50 &&
    magicBytes[2] === 0x44 &&
    magicBytes[3] === 0x46 &&
    magicBytes[4] === 0x2d;

  if (!isPDF) return { valid: false, reason: 'Invalid PDF header — missing %PDF- signature' };

  // Check tail for PDF markers
  const tailBytes = await readTail(input, 256);
  const tail = new TextDecoder().decode(tailBytes);

  if (!tail.includes('%%EOF'))
    return { valid: false, reason: 'Missing %%EOF marker — file likely truncated' };
  if (!tail.includes('startxref'))
    return { valid: false, reason: 'Missing startxref — broken cross-reference table' };

  return { valid: true };
}
